import React, { Component } from 'react';
import { Translate } from '$common';



export default class MultipleImageUpload extends Component {
  static type = 'multiple_image_upload';
  static elementName = Translate.get('multiple_image_upload');
  static icon = 'picture-o';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/multiple-image-upload.js